<template>
    <div>
         <nav-bar-main></nav-bar-main>
         <Loader />  
         <b-row  v-if="plantDetails!=null" class="animated fadeIn mb-5"> 
         <b-col cols="12" id="sezione-general">

         <!-- banner nessun proprietario presente per l'impianto -->
         <b-alert v-if=" !this.hasClient() && (ruoloUtente(this.$store.getters.userId) == 'installer' || ruoloUtente(this.$store.getters.userId) == 'admin')" show variant="info" style="display:inline-block;width:100%">
                    <manage-client></manage-client>
                </b-alert>
                <b-col v-else cols="12" class="mt-3">
          </b-col>    
  

            <!-- titolo impostazioni generali --> 
            <b-row>
                <b-col cols="6">
                    <div id="title-first" class="ml-5 mt-2 typo-label">
                        <i class="fa fa-cog pr-1 pt-1 fa-1x pull-left"></i>
                        <span>{{$t("settings.title")}}: <b>{{$t("settings.general")}}</b></span>
                    </div>
                </b-col>
            </b-row>

            <!-- sezione Passa a pro --> 
            <b-row>
            <b-col cols="12">
                <div id="title-pro" class="ml-5 mt-3 typo-label">
                    <span><b>{{$t("settings.titlePro")}}</b></span>
                </div>

                <b-card id="card-pro" class="mx-5 mt-2 radius-card">
                    <label>{{$t("edit_plant_modal.label_plant_type")}}:</label>
                    <span> <strong> {{$t(plantDetails.plant_type)}} <i v-if="isPro && !$store.getters.isProExpired && 1<0" class="fa fa-check fa-2x" style="color: #009900" /></strong></span>
                    <span v-if="isPro && !$store.getters.isProExpired" v-bind:class="expirySpanClass" class="typo-littleblack">({{$t("edit_plant_modal.expiration")}}: <strong>{{dataScadPro.format("DD/MM/YYYY")}}</strong>)</span>
                    <div v-if="isPro" class="mt-2">
                        <div v-if="$store.getters.isProExpired" class="withError">Attenzione! La modalità <strong>Professional</strong> è terminata il <strong>{{dataScadPro.format("DD/MM/YYYY")}}</strong>. Acquista una nuova chiave di attivazione per ripristinare tutte le funzionalità avanzate. </div>
                        <label>{{$t("edit_plant_modal.activation_keys")}}</label>
                        <table class="table table-striped table-bordered table-sm" >
                          <thead class="thead-light">
                            <tr>
                              <th>{{$t("edit_plant_modal.code")}}</th>
                              <th>{{$t("edit_plant_modal.duration")}}</th>
                              <th>{{$t("edit_plant_modal.date")}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(code) in plantDetails.pro_code" v-bind:key="code.code">
                              <td >{{code.code}}</td>
                              <td>{{code.duration}}</td>
                              <td>{{moment(code.used).format("DD/MM/YYYY")}}</td>
                            </tr>
                          </tbody>
                        </table>
                        <b-row v-if="ruoloUtente(this.$store.getters.userId) == 'installer' || ruoloUtente(this.$store.getters.userId) == 'collab' || ruoloUtente(this.$store.getters.userId) == 'admin'">
                          <b-col lg="2" cols="3" class="text-right pt-2"><label >{{$t("edit_plant_modal.renew")}}:</label></b-col>
                        
                          <b-col lg="4" cols="5">
                            <b-form-group
                            :description="$t('settings.code16')"
                            >
                            <b-form-input id="renewCode" type="text" :placeholder='$t("edit_plant_modal.renewal_code")' v-model="renewCode"></b-form-input> 
                            </b-form-group>
                          </b-col>
                          <b-col>
                          <b-button variant="primary" @click="rinnovaPro">{{$t("edit_plant_modal.renew")}}</b-button> <span v-if="updatingPro"><i class="fa fa-spin fa-spinner" /> Validazione in corso...</span>
                          </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <b-button v-b-toggle.pro-code-collapse variant="primary">{{$t('settings.activePro')}}</b-button>
                        <b-collapse id="pro-code-collapse" class="mt-4">
                            <p>{{$t('settings.claimPro')}}</p>
                            <p>{{$t('settings.buyPro')}}</p>
                            
                            <b-form-group :label="$t('settings.codeActivation')" label-for="proCode" :description="$t('settings.code16')">
                                <b-form-input id="proCode" v-model="codicePro" type="text" required :placeholder="$t('settings.codeActivation')" ></b-form-input>
                            </b-form-group>
                            <b-button @click="abilitaPro()" variant="primary">{{$t('settings.activation')}}</b-button> <span v-if="updatingPro"><i class="fa fa-spin fa-spinner" /> Validazione in corso...</span>
                            
                        </b-collapse>
                    </div>
               </b-card>       
            </b-col>    
            </b-row>

            <!-- sezione modifica dati anagrafici impianto --> 
            <b-row class="mb-5">
            <b-col xl="6" lg="6" md="12" sm="12">
            <b-row>
            <b-col>
                <div id="title-edit" class="ml-5 typo-label">
                    <span><b>{{$t("settings.plantAnag")}}</b></span>
                </div>
                <b-card id="card-edit" class="ml-5 mr-5 mt-2 radius-card">
                    <b-form-group>
                        <label for="label-plant-name">{{$t("edit_plant_modal.label_plant_name")}}</label>
                        <b-form-input 
                        v-model="plantName" 
                        type="text" 
                        id="placeholder-plant-name"
                        :placeholder="$t('new_plant_modal.placeholder_plant_name')"
                        :state="validation_plantName">
                        </b-form-input>
                        <b-form-invalid-feedback
                        :state="validation_plantName"
                        >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                    </b-form-group>

            <b-form-group>
              <b-row>
                <b-col sm="8">
                  <b-form-group>
                    <label for="label-plant-street">{{$t("edit_plant_modal.label_plant_street")}}</label>
                    <b-form-input
                      v-model="plantStreet"
                      type="text"
                      :state="validation_plantStreet"
                      id="placeholder-plant-street"
                      :placeholder="$t('edit_plant_modal.placeholder_plant_street')"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      :state="validation_plantStreet"
                    >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="label-plant-number">{{$t("edit_plant_modal.label_plant_number")}}</label>
                    <b-form-input
                      v-model="plantNumber"
                      type="text"
                      :state="validation_plantNumber"
                      id="placeholder-plant-number"
                      :placeholder="$t('edit_plant_modal.placeholder_plant_number')"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      :state="validation_plantNumber"
                    >{{$t("new_plant_modal.validation_plantNumber")}}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
            <b-row>
              <b-col sm="8">
                <b-form-group>
                  <label for="label-plant-city">{{$t("edit_plant_modal.label_plant_city")}}</label>
                  <b-form-input
                    v-model="plantCity"
                    type="text"
                    :state="validation_plantCity"
                    id="placeholder-plant-city"
                    :placeholder="$t('edit_plant_modal.placeholder_plant_city')"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    :state="validation_plantCity"
                  >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="label-plant-cap">{{$t("edit_plant_modal.label_plant_cap")}}</label>
                  <b-form-input
                    v-model="plantCap"
                    type="text"
                    :state="validation_plantCap"
                    id="placeholder-plant-cap"
                    :placeholder="$t('edit_plant_modal.placeholder_plant_cap')"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    :state="validation_plantCap"
                  >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group>
              <b-row>
                <b-col sm="8">
                  <b-form-group>
                    <label for="label-plant-prov">{{$t("edit_plant_modal.label_plant_prov")}}</label>
                    <b-form-input
                      v-model="plantProv"
                      type="text"
                      :state="validation_plantProv"
                      id="placeholder-plant-prov"
                      :placeholder="$t('edit_plant_modal.placeholder_plant_prov')"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      :state="validation_plantProv"
                    >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="label-plant-country">{{$t("edit_plant_modal.label_plant_country")}}</label>
                    <b-form-select v-model="plantCountry" :country="country">
                      <option :value="null">{{$t("edit_plant_modal.placeholder_plant_country")}}</option>
                      <option value="AF">Afghanistan</option>
                      <option value="AX">Åland Islands</option>
                      <option value="AL">Albania</option>
                      <option value="DZ">Algeria</option>
                      <option value="AS">American Samoa</option>
                      <option value="AD">Andorra</option>
                      <option value="AO">Angola</option>
                      <option value="AI">Anguilla</option>
                      <option value="AQ">Antarctica</option>
                      <option value="AG">Antigua and Barbuda</option>
                      <option value="AR">Argentina</option>
                      <option value="AM">Armenia</option>
                      <option value="AW">Aruba</option>
                      <option value="AU">Australia</option>
                      <option value="AT">Austria</option>
                      <option value="AZ">Azerbaijan</option>
                      <option value="BS">Bahamas</option>
                      <option value="BH">Bahrain</option>
                      <option value="BD">Bangladesh</option>
                      <option value="BB">Barbados</option>
                      <option value="BY">Belarus</option>
                      <option value="BE">Belgium</option>
                      <option value="BZ">Belize</option>
                      <option value="BJ">Benin</option>
                      <option value="BM">Bermuda</option>
                      <option value="BT">Bhutan</option>
                      <option value="BO">Bolivia, Plurinational State of</option>
                      <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                      <option value="BA">Bosnia and Herzegovina</option>
                      <option value="BW">Botswana</option>
                      <option value="BV">Bouvet Island</option>
                      <option value="BR">Brazil</option>
                      <option value="IO">British Indian Ocean Territory</option>
                      <option value="BN">Brunei Darussalam</option>
                      <option value="BG">Bulgaria</option>
                      <option value="BF">Burkina Faso</option>
                      <option value="BI">Burundi</option>
                      <option value="KH">Cambodia</option>
                      <option value="CM">Cameroon</option>
                      <option value="CA">Canada</option>
                      <option value="CV">Cape Verde</option>
                      <option value="KY">Cayman Islands</option>
                      <option value="CF">Central African Republic</option>
                      <option value="TD">Chad</option>
                      <option value="CL">Chile</option>
                      <option value="CN">China</option>
                      <option value="CX">Christmas Island</option>
                      <option value="CC">Cocos (Keeling) Islands</option>
                      <option value="CO">Colombia</option>
                      <option value="KM">Comoros</option>
                      <option value="CG">Congo</option>
                      <option value="CD">Congo, the Democratic Republic of the</option>
                      <option value="CK">Cook Islands</option>
                      <option value="CR">Costa Rica</option>
                      <option value="CI">Côte d'Ivoire</option>
                      <option value="HR">Croatia</option>
                      <option value="CU">Cuba</option>
                      <option value="CW">Curaçao</option>
                      <option value="CY">Cyprus</option>
                      <option value="CZ">Czech Republic</option>
                      <option value="DK">Denmark</option>
                      <option value="DJ">Djibouti</option>
                      <option value="DM">Dominica</option>
                      <option value="DO">Dominican Republic</option>
                      <option value="EC">Ecuador</option>
                      <option value="EG">Egypt</option>
                      <option value="SV">El Salvador</option>
                      <option value="GQ">Equatorial Guinea</option>
                      <option value="ER">Eritrea</option>
                      <option value="EE">Estonia</option>
                      <option value="ET">Ethiopia</option>
                      <option value="FK">Falkland Islands (Malvinas)</option>
                      <option value="FO">Faroe Islands</option>
                      <option value="FJ">Fiji</option>
                      <option value="FI">Finland</option>
                      <option value="FR">France</option>
                      <option value="GF">French Guiana</option>
                      <option value="PF">French Polynesia</option>
                      <option value="TF">French Southern Territories</option>
                      <option value="GA">Gabon</option>
                      <option value="GM">Gambia</option>
                      <option value="GE">Georgia</option>
                      <option value="DE">Germany</option>
                      <option value="GH">Ghana</option>
                      <option value="GI">Gibraltar</option>
                      <option value="GR">Greece</option>
                      <option value="GL">Greenland</option>
                      <option value="GD">Grenada</option>
                      <option value="GP">Guadeloupe</option>
                      <option value="GU">Guam</option>
                      <option value="GT">Guatemala</option>
                      <option value="GG">Guernsey</option>
                      <option value="GN">Guinea</option>
                      <option value="GW">Guinea-Bissau</option>
                      <option value="GY">Guyana</option>
                      <option value="HT">Haiti</option>
                      <option value="HM">Heard Island and McDonald Islands</option>
                      <option value="VA">Holy See (Vatican City State)</option>
                      <option value="HN">Honduras</option>
                      <option value="HK">Hong Kong</option>
                      <option value="HU">Hungary</option>
                      <option value="IS">Iceland</option>
                      <option value="IN">India</option>
                      <option value="ID">Indonesia</option>
                      <option value="IR">Iran, Islamic Republic of</option>
                      <option value="IQ">Iraq</option>
                      <option value="IE">Ireland</option>
                      <option value="IM">Isle of Man</option>
                      <option value="IL">Israel</option>
                      <option value="IT">Italy</option>
                      <option value="JM">Jamaica</option>
                      <option value="JP">Japan</option>
                      <option value="JE">Jersey</option>
                      <option value="JO">Jordan</option>
                      <option value="KZ">Kazakhstan</option>
                      <option value="KE">Kenya</option>
                      <option value="KI">Kiribati</option>
                      <option value="KP">Korea, Democratic People's Republic of</option>
                      <option value="KR">Korea, Republic of</option>
                      <option value="KW">Kuwait</option>
                      <option value="KG">Kyrgyzstan</option>
                      <option value="LA">Lao People's Democratic Republic</option>
                      <option value="LV">Latvia</option>
                      <option value="LB">Lebanon</option>
                      <option value="LS">Lesotho</option>
                      <option value="LR">Liberia</option>
                      <option value="LY">Libya</option>
                      <option value="LI">Liechtenstein</option>
                      <option value="LT">Lithuania</option>
                      <option value="LU">Luxembourg</option>
                      <option value="MO">Macao</option>
                      <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                      <option value="MG">Madagascar</option>
                      <option value="MW">Malawi</option>
                      <option value="MY">Malaysia</option>
                      <option value="MV">Maldives</option>
                      <option value="ML">Mali</option>
                      <option value="MT">Malta</option>
                      <option value="MH">Marshall Islands</option>
                      <option value="MQ">Martinique</option>
                      <option value="MR">Mauritania</option>
                      <option value="MU">Mauritius</option>
                      <option value="YT">Mayotte</option>
                      <option value="MX">Mexico</option>
                      <option value="FM">Micronesia, Federated States of</option>
                      <option value="MD">Moldova, Republic of</option>
                      <option value="MC">Monaco</option>
                      <option value="MN">Mongolia</option>
                      <option value="ME">Montenegro</option>
                      <option value="MS">Montserrat</option>
                      <option value="MA">Morocco</option>
                      <option value="MZ">Mozambique</option>
                      <option value="MM">Myanmar</option>
                      <option value="NA">Namibia</option>
                      <option value="NR">Nauru</option>
                      <option value="NP">Nepal</option>
                      <option value="NL">Netherlands</option>
                      <option value="NC">New Caledonia</option>
                      <option value="NZ">New Zealand</option>
                      <option value="NI">Nicaragua</option>
                      <option value="NE">Niger</option>
                      <option value="NG">Nigeria</option>
                      <option value="NU">Niue</option>
                      <option value="NF">Norfolk Island</option>
                      <option value="MP">Northern Mariana Islands</option>
                      <option value="NO">Norway</option>
                      <option value="OM">Oman</option>
                      <option value="PK">Pakistan</option>
                      <option value="PW">Palau</option>
                      <option value="PS">Palestinian Territory, Occupied</option>
                      <option value="PA">Panama</option>
                      <option value="PG">Papua New Guinea</option>
                      <option value="PY">Paraguay</option>
                      <option value="PE">Peru</option>
                      <option value="PH">Philippines</option>
                      <option value="PN">Pitcairn</option>
                      <option value="PL">Poland</option>
                      <option value="PT">Portugal</option>
                      <option value="PR">Puerto Rico</option>
                      <option value="QA">Qatar</option>
                      <option value="RE">Réunion</option>
                      <option value="RO">Romania</option>
                      <option value="RU">Russian Federation</option>
                      <option value="RW">Rwanda</option>
                      <option value="BL">Saint Barthélemy</option>
                      <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                      <option value="KN">Saint Kitts and Nevis</option>
                      <option value="LC">Saint Lucia</option>
                      <option value="MF">Saint Martin (French part)</option>
                      <option value="PM">Saint Pierre and Miquelon</option>
                      <option value="VC">Saint Vincent and the Grenadines</option>
                      <option value="WS">Samoa</option>
                      <option value="SM">San Marino</option>
                      <option value="ST">Sao Tome and Principe</option>
                      <option value="SA">Saudi Arabia</option>
                      <option value="SN">Senegal</option>
                      <option value="RS">Serbia</option>
                      <option value="SC">Seychelles</option>
                      <option value="SL">Sierra Leone</option>
                      <option value="SG">Singapore</option>
                      <option value="SX">Sint Maarten (Dutch part)</option>
                      <option value="SK">Slovakia</option>
                      <option value="SI">Slovenia</option>
                      <option value="SB">Solomon Islands</option>
                      <option value="SO">Somalia</option>
                      <option value="ZA">South Africa</option>
                      <option value="GS">South Georgia and the South Sandwich Islands</option>
                      <option value="SS">South Sudan</option>
                      <option value="ES">Spain</option>
                      <option value="LK">Sri Lanka</option>
                      <option value="SD">Sudan</option>
                      <option value="SR">Suriname</option>
                      <option value="SJ">Svalbard and Jan Mayen</option>
                      <option value="SZ">Swaziland</option>
                      <option value="SE">Sweden</option>
                      <option value="CH">Switzerland</option>
                      <option value="SY">Syrian Arab Republic</option>
                      <option value="TW">Taiwan, Province of China</option>
                      <option value="TJ">Tajikistan</option>
                      <option value="TZ">Tanzania, United Republic of</option>
                      <option value="TH">Thailand</option>
                      <option value="TL">Timor-Leste</option>
                      <option value="TG">Togo</option>
                      <option value="TK">Tokelau</option>
                      <option value="TO">Tonga</option>
                      <option value="TT">Trinidad and Tobago</option>
                      <option value="TN">Tunisia</option>
                      <option value="TR">Turkey</option>
                      <option value="TM">Turkmenistan</option>
                      <option value="TC">Turks and Caicos Islands</option>
                      <option value="TV">Tuvalu</option>
                      <option value="UG">Uganda</option>
                      <option value="UA">Ukraine</option>
                      <option value="AE">United Arab Emirates</option>
                      <option value="GB">United Kingdom</option>
                      <option value="US">United States</option>
                      <option value="UM">United States Minor Outlying Islands</option>
                      <option value="UY">Uruguay</option>
                      <option value="UZ">Uzbekistan</option>
                      <option value="VU">Vanuatu</option>
                      <option value="VE">Venezuela, Bolivarian Republic of</option>
                      <option value="VN">Viet Nam</option>
                      <option value="VG">Virgin Islands, British</option>
                      <option value="VI">Virgin Islands, U.S.</option>
                      <option value="WF">Wallis and Futuna</option>
                      <option value="EH">Western Sahara</option>
                      <option value="YE">Yemen</option>
                      <option value="ZM">Zambia</option>
                      <option value="ZW">Zimbabwe</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="showInformativa()==true">
               <b-col cols="12">
                <b-form-checkbox
                  id="chk_nomina"
                  v-model="nomina_checked"
                  name="chk_nomina"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  <b-button class="my-0 py-0" v-b-modal.modal-nomina variant="link">{{$t("settings.read_accept")}}</b-button>
                </b-form-checkbox>
               </b-col>    
              </b-row>
              <b-row>
                <b-col cols="12" v-if="$store.getters.userRole == 'installer' || $store.getters.userRole == 'collab' || $store.getters.userRole == 'admin'">
                  
                  <b-button
                    @click="handleOk()"
                    variant="info"
                    style="color:white; background-color:#009DE0"
                    class="mt-1 float-right"
                  >{{$t("settings.buttonUpdateAnag")}}</b-button>
                </b-col>
              </b-row>
            </b-form-group>
            </b-card>

            <!-- Sezione Logo Impianto -->

            <div id="title-edit" class="ml-5 typo-label">
                <span class="pl-2 pl-sm-0"><b>{{$t("settings.manageLogoTitle")}}</b></span>
            </div>
            <b-card id="card-logo" class="mx-4 mx-md-5 mt-2 radius-card">
                <div id="dropLogoContainer" >
                  <!--<div style="position: absolute; width: 100%; display: block; text-align: center">
                    <img :src="logoUrl()" style="max-height: 200px; max-width: 500px; margin-left: auto; margin-right: auto" />
                  </div>--> 
                  <!--
                  <div style="position: absolute; width: 100%; height: 100%; display: block; text-align: center">
                    <div style="margin-top: auto; margin-bottom:auto">Rilascia un'immagine qui per aggiornare il logo</div>
                  </div>-->
                <vue-dropzone ref="myLogoDropzone" id="logoDropzone" :options="logoDropZoneOptions" v-on:vdropzone-file-added="logoAdded" v-on:vdropzone-sending="sendingLogo" 
                
                :style="'height: 200px; background-image: url(\'' + logoUrl() + '\'); background-size: contain; background-repeat: no-repeat; background-position: center'" >
                  
                </vue-dropzone>
                
                </div>
            </b-card>

            <!-- Sezione dati cliente -->
                <div id="title-edit" class="ml-5 typo-label">
                    <span><b>{{$t("manage_client_modal.modify_anag")}}</b></span>
                </div>
                <b-card id="card-edit" class="ml-5 mr-5 mt-2 radius-card">
                
        <b-form-group :disabled="ruoloUtente(this.$store.getters.userId) != 'installer' && ruoloUtente(this.$store.getters.userId) != 'admin' && ruoloUtente(this.$store.getters.userId) != 'collab'">
          <b-row>
           <b-col sm="12">
               <b-form-group class="m-3">
                  <b-form-radio class="ml-4 mb-2" v-model="clientPicked" name="PersonComp" value="company">{{$t("user_modal.label_company")}}</b-form-radio>
                  <b-form-radio class="ml-4 mb-2" v-model="clientPicked" name="PersonComp" value="person">{{$t("user_modal.label_people")}}</b-form-radio>
               </b-form-group>
           </b-col> 
           <b-col sm="5" class="mr-1">
                <b-form-group v-if="clientPicked=='person'">
                    <label for="label-name" class="ml-2">{{$t("user_modal.label_name")}}</label>
                    <b-form-input v-model="clientName" type="text" :state="validation_clientname" id="placeholder-installer-name" :placeholder="'* '+$t('user_modal.placeholder_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_clientname">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>        
            <b-col sm="5" v-if="clientPicked=='person'">
                <b-form-group>
                    <label for="label-surname" class="ml-2">{{$t("user_modal.label_surname")}}</label>
                    <b-form-input v-model="clientSurname" type="text" :state="validation_clientsurname" id="placeholder-installer-surname" :placeholder="'* '+$t('user_modal.placeholder_surname')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_clientsurname">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="10" class="mr-1">
                <b-form-group v-if="clientPicked=='company'">
                    <label for="label-business-name" class="ml-2">{{$t("user_modal.label_business_name")}}</label>
                    <b-form-input v-model="clientbusinessName" type="text" :state="validation_clientbusinessName" id="placeholder-installer-business-name" :placeholder="$t('user_modal.placeholder_business_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_clientbusinessName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>     
            <b-col sm="10" class="mr-1">
                <b-form-group v-if="clientPicked=='company'">
                    <label for="label-piva" class="ml-2">{{$t("user_modal.label_piva")}}</label>
                    <b-form-input v-model="clientPiva" type="text" :state="validation_clientPiva" id="placeholder-installer-piva" :placeholder="$t('user_modal.placeholder_piva')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_clientPiva">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="10" class="mr-1">
                <b-form-group>
                    <label for="label-phone" class="ml-2">{{$t("user_modal.label_phone")}}</label>
                    <b-form-input v-model="clientPhone" type="text" id="placeholder-installer-phone"></b-form-input>
                    <b-form-invalid-feedback>{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="10" class="mr-1">
                <b-form-group>
                    <label for="label-email" class="ml-2">{{$t("signup.emailAddress")}}</label>
                    <b-form-input v-model="clientEmail" type="text" :state="validation_clientemail" id="placeholder-installer-mail"></b-form-input>
                    <b-form-invalid-feedback :state="validation_clientemail">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="7">
              <b-form-group>
                <label for="label-installer-street" class="ml-2">{{$t("user_modal.label_street")}}</label>
                <b-form-input v-model="clientStreet" type="text" :state="validation_clientStreet" id="placeholder-installer-street"></b-form-input>
                <b-form-invalid-feedback :state="validation_clientStreet">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mr-1">
              <b-form-group>
                <label for="label-installer-number" class="ml-2">{{$t("user_modal.label_number")}}</label>
                <b-form-input v-model="clientNumber" type="text" :state="validation_clientNumber" id="placeholder-installer-number" ></b-form-input>
                <b-form-invalid-feedback :state="validation_clientNumber">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="7">
              <b-form-group>
                <label for="label-installer-city" class="ml-2">{{$t("user_modal.label_city")}}</label>
                <b-form-input v-model="clientCity" type="text" :state="validation_clientCity" id="placeholder-installer-city"></b-form-input>
                <b-form-invalid-feedback :state="validation_clientCity">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mr-1">
              <b-form-group>
                <label for="label-installer-cap" class="ml-2">{{$t("user_modal.label_cap")}}</label>
                <b-form-input v-model="clientCap" type="text" :state="validation_clientCap" id="placeholder-installer-cap"></b-form-input>
                <b-form-invalid-feedback :state="validation_clientCap">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="7">
              <b-form-group>
                <label for="label-installer-prov" class="ml-2">{{$t("user_modal.label_prov")}}</label>
                <b-form-input v-model="clientProv" type="text" :state="validation_clientProv" id="placeholder-installer-prov"></b-form-input>
                <b-form-invalid-feedback :state="validation_clientProv">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mr-1">
              <b-form-group>
                <label for="label-installer-country" class="ml-2">{{$t("user_modal.label_country")}}</label>
                <b-form-select v-model="clientCountry" :country="clientcountry" >
                    <option :value="null">{{$t("user_modal.placeholder_country")}}</option>        
                    <option value="AF">Afghanistan</option>
                    <option value="AX">Åland Islands</option>
                    <option value="AL">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AS">American Samoa</option>
                    <option value="AD">Andorra</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AQ">Antarctica</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AW">Aruba</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BD">Bangladesh</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia, Plurinational State of</option>
                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                    <option value="BA">Bosnia and Herzegovina</option>
                    <option value="BW">Botswana</option>
                    <option value="BV">Bouvet Island</option>
                    <option value="BR">Brazil</option>
                    <option value="IO">British Indian Ocean Territory</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option value="BI">Burundi</option>
                    <option value="KH">Cambodia</option>
                    <option value="CM">Cameroon</option>
                    <option value="CA">Canada</option>
                    <option value="CV">Cape Verde</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="CF">Central African Republic</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CX">Christmas Island</option>
                    <option value="CC">Cocos (Keeling) Islands</option>
                    <option value="CO">Colombia</option>
                    <option value="KM">Comoros</option>
                    <option value="CG">Congo</option>
                    <option value="CD">Congo, the Democratic Republic of the</option>
                    <option value="CK">Cook Islands</option>
                    <option value="CR">Costa Rica</option>
                    <option value="CI">Côte d'Ivoire</option>
                    <option value="HR">Croatia</option>
                    <option value="CU">Cuba</option>
                    <option value="CW">Curaçao</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option value="DK">Denmark</option>
                    <option value="DJ">Djibouti</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="GQ">Equatorial Guinea</option>
                    <option value="ER">Eritrea</option>
                    <option value="EE">Estonia</option>
                    <option value="ET">Ethiopia</option>
                    <option value="FK">Falkland Islands (Malvinas)</option>
                    <option value="FO">Faroe Islands</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option value="GF">French Guiana</option>
                    <option value="PF">French Polynesia</option>
                    <option value="TF">French Southern Territories</option>
                    <option value="GA">Gabon</option>
                    <option value="GM">Gambia</option>
                    <option value="GE">Georgia</option>
                    <option value="DE">Germany</option>
                    <option value="GH">Ghana</option>
                    <option value="GI">Gibraltar</option>
                    <option value="GR">Greece</option>
                    <option value="GL">Greenland</option>
                    <option value="GD">Grenada</option>
                    <option value="GP">Guadeloupe</option>
                    <option value="GU">Guam</option>
                    <option value="GT">Guatemala</option>
                    <option value="GG">Guernsey</option>
                    <option value="GN">Guinea</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option value="HT">Haiti</option>
                    <option value="HM">Heard Island and McDonald Islands</option>
                    <option value="VA">Holy See (Vatican City State)</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IR">Iran, Islamic Republic of</option>
                    <option value="IQ">Iraq</option>
                    <option value="IE">Ireland</option>
                    <option value="IM">Isle of Man</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JE">Jersey</option>
                    <option value="JO">Jordan</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KI">Kiribati</option>
                    <option value="KP">Korea, Democratic People's Republic of</option>
                    <option value="KR">Korea, Republic of</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option value="LA">Lao People's Democratic Republic</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LS">Lesotho</option>
                    <option value="LR">Liberia</option>
                    <option value="LY">Libya</option>
                    <option value="LI">Liechtenstein</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option value="MO">Macao</option>
                    <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="MV">Maldives</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MQ">Martinique</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="YT">Mayotte</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia, Federated States of</option>
                    <option value="MD">Moldova, Republic of</option>
                    <option value="MC">Monaco</option>
                    <option value="MN">Mongolia</option>
                    <option value="ME">Montenegro</option>
                    <option value="MS">Montserrat</option>
                    <option value="MA">Morocco</option>
                    <option value="MZ">Mozambique</option>
                    <option value="MM">Myanmar</option>
                    <option value="NA">Namibia</option>
                    <option value="NR">Nauru</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="NC">New Caledonia</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NU">Niue</option>
                    <option value="NF">Norfolk Island</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="NO">Norway</option>
                    <option value="OM">Oman</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PS">Palestinian Territory, Occupied</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PN">Pitcairn</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="QA">Qatar</option>
                    <option value="RE">Réunion</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russian Federation</option>
                    <option value="RW">Rwanda</option>
                    <option value="BL">Saint Barthélemy</option>
                    <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                    <option value="KN">Saint Kitts and Nevis</option>
                    <option value="LC">Saint Lucia</option>
                    <option value="MF">Saint Martin (French part)</option>
                    <option value="PM">Saint Pierre and Miquelon</option>
                    <option value="VC">Saint Vincent and the Grenadines</option>
                    <option value="WS">Samoa</option>
                    <option value="SM">San Marino</option>
                    <option value="ST">Sao Tome and Principe</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="RS">Serbia</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SX">Sint Maarten (Dutch part)</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="SO">Somalia</option>
                    <option value="ZA">South Africa</option>
                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                    <option value="SS">South Sudan</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SD">Sudan</option>
                    <option value="SR">Suriname</option>
                    <option value="SJ">Svalbard and Jan Mayen</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="SY">Syrian Arab Republic</option>
                    <option value="TW">Taiwan, Province of China</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania, United Republic of</option>
                    <option value="TH">Thailand</option>
                    <option value="TL">Timor-Leste</option>
                    <option value="TG">Togo</option>
                    <option value="TK">Tokelau</option>
                    <option value="TO">Tonga</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos Islands</option>
                    <option value="TV">Tuvalu</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UM">United States Minor Outlying Islands</option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option value="VU">Vanuatu</option>
                    <option value="VE">Venezuela, Bolivarian Republic of</option>
                    <option value="VN">Viet Nam</option>
                    <option value="VG">Virgin Islands, British</option>
                    <option value="VI">Virgin Islands, U.S.</option>
                    <option value="WF">Wallis and Futuna</option>
                    <option value="EH">Western Sahara</option>
                    <option value="YE">Yemen</option>
                    <option value="ZM">Zambia</option>
                    <option value="ZW">Zimbabwe</option>
                </b-form-select> 
              </b-form-group>
            </b-col>
            </b-row>   
            <b-row>
               <b-col cols="12">
                  <label>{{$t("user_modal.fields")}}</label> 
               </b-col>    
            </b-row>    
            <b-row v-if="ruoloUtente(this.$store.getters.userId) == 'installer' || ruoloUtente(this.$store.getters.userId) == 'admin' || ruoloUtente(this.$store.getters.userId) == 'collab'">
              <b-col cols="12">
                <b-button
                    @click="saveClient()"
                    variant="info"
                    :disabled="!saveClientEnabled"
                    style="color:white; background-color:#009DE0"
                    class="mt-1 float-right"
                  >{{$t("manage_client_modal.update_anag")}}</b-button>
              </b-col>
            </b-row>
          </b-form-group>
          

                </b-card>
            </b-col>
            </b-row>
            <b-row>
            <b-col v-if="isPro && !$store.getters.isProExpired">
              <div id="title-notifiche" class="ml-5 typo-label">
                <span><b>{{$t("settings.title_notifiche")}}</b></span>
              </div>
              <b-card id="card-notifiche" class="ml-5 mr-5 mt-2 radius-card">
                <b-form-checkbox  v-model="errorNotifications" switch size="lg" @change="modificaStatoNotifiche">{{$t("settings.label_notifiche")}}</b-form-checkbox>
                <p>{{$t("settings.subtitle_notifiche")}}</p>
              </b-card>
            </b-col>
            </b-row>
            </b-col>
            <b-col xl="6" lg="6" md="12" sm="12">
              <!-- Plant Google Map -->
              <div id="title-map" class="ml-5 typo-label">
                    <span><b>{{$t("settings.plantMap")}}</b></span>
              </div>
              <b-card id="card-map" class="ml-5 mr-5 mt-2 pb-4 radius-card">
                  <div class="embed-responsive embed-responsive-4by3 radius-card h-100">
                    <plant-map />
                  </div>
              </b-card>

              <!-- Allegati -->
              <div id="title-allegati" class="ml-4 ml-md-5 typo-label">
                    <span><b>{{$t("settings.titleAllegati")}}</b></span>
              </div>
              <b-card id="card-allegati" class="mx-4 mx-md-5 mt-2 pb-4 radius-card">
                <div v-if="ruoloUtente(this.$store.getters.userId) == 'installer' || ruoloUtente(this.$store.getters.userId) == 'admin' || ruoloUtente(this.$store.getters.userId) == 'collab'">{{$t("settings.note_manage_file")}}</div>
                <div v-if="ruoloUtente(this.$store.getters.userId) == 'installer' || ruoloUtente(this.$store.getters.userId) == 'admin' || ruoloUtente(this.$store.getters.userId) == 'collab'" id="dropFilesContainer" > 
                    <vue-dropzone ref="myFileDropzone" id="fileDropzone" 
                    :options="fileDropZoneOptions" 
                    v-on:vdropzone-file-added="fileAdded" 
                    v-on:vdropzone-sending="sendingFile" 
                    style="min-height: 60px; height: 60px">
                    </vue-dropzone>
                </div>

                <b-table-simple hover small>
                  <b-thead>
                    <b-tr>
                      <b-th>File</b-th>
                      <b-th class="text-right">{{$t("settings.size")}}</b-th>
                      <b-th class="text-right">{{$t("settings.delete")}}</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(docfile,index) in documents" v-bind:key="docfile.id">
                      <b-td><a  
                        :href="'/plants_documents/' + docfile.id"
                        v-text="docfile.title"
                        @click.prevent="downloadFile(docfile)"
                      /></b-td>
                      <b-td class="text-right">{{formatFileSize(docfile.size)}}</b-td>
                      <b-td class="text-right"><b-button v-if="ruoloUtente($store.getters.userId) == 'installer' || ruoloUtente($store.getters.userId) == 'admin' || ruoloUtente($store.getters.userId) == 'collab'"  variant="danger" @click="eliminaFile(docfile,index)"><i class="fa fa-trash" style="color:white" ></i></b-button></b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>

              </b-card>


            </b-col>

            </b-row >

         </b-col>
        </b-row>

        
    <!-- modal dati aggiornati or error -->
    <b-modal ref="modal-saved" 
      hide-header
      no-close-on-backdrop
      ok-only
      centered
      @ok="SavedData">
      <div class="d-block text-center p-5">
        <i v-if="this.savedMessage==this.$t('manage_client_modal.saved_data')" class="fa fa-check fa-2x" style="color:green"></i>
        <i v-else-if="this.savedMessage==this.$t('manage_client_modal.select_option')" class="fa fa-info-circle fa-2x" style="color:#009DE0"></i>
        <i v-else class="fa fa-exclamation-triangle fa-2x" style="color:red"></i>
        <span class="p-3 h6">{{this.savedMessage}}</span>
      </div>
    </b-modal>

    <!-- modal nomina dati cliente -->
    <b-modal ref="modal-nomina" id="modal-nomina" size="lg" 
      title="Nomina trattamento dati cliente"
      :scrollable="true"
      ok-only
      centered
      >
      <div class="border p-3">
            <accettazione-nomina-ITA v-if="$t('language')=='IT'"></accettazione-nomina-ITA>
            <accettazione-nomina-ENG v-else></accettazione-nomina-ENG>
      </div>
    </b-modal>

    </div>
</template>


<script>

import Vue from 'vue';
import NavBarMain from '@/components/NavBarMain';
import Avatar from 'vue-avatar';
import axios from "axios";
import PlantMap from "@/components/PlantMap";
import ManageClient from '@/components/ManageClient';
import { mapState } from 'vuex';

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import AccettazioneNominaITA from '@/locales/AccettazioneNominaITA';
import AccettazioneNominaENG from '@/locales/AccettazioneNominaENG'

export default {
    name: 'GeneraliImpianto',
    components: {
        NavBarMain,
        PlantMap,
        ManageClient,
        AccettazioneNominaITA,
        AccettazioneNominaENG,
        vueDropzone: vue2Dropzone,
    },
data() {
    return {
      nomina_checked: "",
      updatingPro: false,
      codicePro: "",
      renewCode: "",
      plantId:"",
      plantName: "",
      plantStreet: "",
      plantNumber: "",
      plantCity: "",
      plantCap: "",
      plantProv: "",
      plantCountry: "IT",
      country: null,
      saveSubmit: "false",
      saveUser:"false",
      savedMessage:"",
      clientPicked:"company",
      clientEmail: '',
      clientPiva:'',
      clientPhone:'',
      clientStreet:'',
      clientNumber:'',
      clientCity:'',
      clientCap:'',
      clientProv:'',
      clientbusinessName:'',
      clientName: '',
      clientSurname: '',
      clientCountry:"IT",
      clientcountry: null,
      saveSubmitClient: false,
      saveClientEnabled: true,

      logoDropZoneOptions: {
          url: process.env.VUE_APP_API_REST_URL,
          maxFilesize: 1.5,
          acceptFiles: "image/*",
          autoProcessQueue: false,
          autoQueue: false,
          maxFiles: 1
      },

      fileDropZoneOptions: {
          url: process.env.VUE_APP_API_REST_URL,
          maxFilesize: 30,
          acceptFiles: "*/*",
          autoProcessQueue: false,
          autoQueue: false,
          maxFiles: 1
      },

      errorNotifications: false,
      accessToken: "pk.eyJ1IjoiYmVnaGVsbGlkZXYiLCJhIjoiY2s4dHdzMTB1MDN2YjNwbXd3aTBjZ25payJ9.bGime-PtFWnugxAAL1G3yQ",
      apiUrl: "https://api.mapbox.com/geocoding/v5/mapbox.places/"
     }
    },
    computed: {
            ...mapState(['commandResponse','error','loading']),
            isPro() {
                const plant = this.$store.state.currentPlant;
                if (plant == null) return false;
                return (plant.plant_type == 'pro' || plant.plant_type == 'premium');
            },
            /*isProExpired() {
              const plant = this.$store.state.currentPlant;
                if (plant == null) return false;
                if (plant.plant_type == 'pro') {
                  if (plant.pro_expiry == null || plant.pro_expiry == "" || plant.pro_expiry == 'null') return true;
                  const adesso = new Date();
                  const expDate = new Date(Date.parse(plant.pro_expiry));
                  console.log("pro expiry:" + plant.pro_expiry + ", expDate:" + expDate+", adesso:" + adesso);
                  if ( expDate.getTime() < adesso.getTime()) return true;
                }
                return false;
            },*/
            documents() {
              if (this.plantDetails == null || this.plantDetails.documents == null) return [];
              return this.plantDetails.documents;
            },
            enableNotifications() {
              const plant = this.$store.state.currentPlant;
              if (plant == null) return false;
              if (plant.plant_type != 'pro' || this.$store.getters.isProExpired) return false;
              if (plant.send_notifications == null) return false;
              return plant.send_notifications;
            },
            dataScadPro() {
              const plant = this.$store.state.currentPlant;
              if (plant == null || plant.pro_expiry == null || plant.pro_expiry == "" || plant.pro_expiry == 'null') return this.moment().add(-1,'d');
              console.log("expiry",plant.pro_expiry);
              return this.moment(plant.pro_expiry);
            },
            expirySpanClass() {
              var dataScad = this.dataScadPro;
              var adesso = this.moment();
              if (dataScad.diff(adesso) < 0) return ['text-danger'];
              if (dataScad.diff(adesso,'days') <= 10) return ['scad-warning'];
              return ['scad-ok'];
              
            },
            plantDetails() {
                const plant = this.$store.state.currentPlant;
                if (plant == null) return null;
                //if (plant.id != this.plantId) return null;
                console.log("PLANT DETAILS",plant);
                this.chargeCurrentSettings();
                return plant;
            },
            validation_userName() {
                if(this.saveUser==true) return this.userName.length > 0
            },
            validation_userSurname() {
                    if(this.saveUser==true) return this.userSurname.length > 0
                },
            validation_userbusinessName() {
                    if(this.saveUser==true) return this.userbusinessName.length > 0
                },
            validation_userStreet() {
                    if(this.saveUser==true) return this.userStreet.length > 0
                },
            validation_userPiva() {
                    if(this.saveUser==true) return this.userPiva.length > 7 && this.userPiva.length < 13
                },
            validation_userPhone() {
                    if(this.saveUser==true) return this.userPhone.length > 0
                },
            validation_userNumber() {
                    if(this.saveUser==true) return this.userNumber.length > 0
                },
            validation_userCity() {
                    if(this.saveUser==true) return this.userCity.length > 0
                },  
            validation_userCap() {
                    if(this.saveUser==true) return this.userCap.length > 0
                },   
            validation_userProv() {
                    if(this.saveUser==true) return this.userProv.length > 0
                },    
            validation_userCountry() {
                    if(this.saveUser==true) return this.userCapCountry.length > 0
                },
            validation_plantName() {
            if (this.saveSubmit == true) return this.plantName.length > 0;
            },
            validation_plantStreet() {
            if (this.saveSubmit == true) return this.plantStreet.length > 0;
            },
            validation_plantNumber() {
              if (this.saveSubmit == true) return ((this.plantNumber.length > 0) && (/^[a-zA-Z0-9-]*$/.test(this.plantNumber)))
            },
            validation_plantCity() {
            if (this.saveSubmit == true) return this.plantCity.length > 0;
            },
            validation_plantCap() {
            if (this.saveSubmit == true) return this.plantCap.length > 0;
            },
            validation_plantProv() {
            if (this.saveSubmit == true) return this.plantProv.length > 0;
            },
            validation_plantCountry() {
            if (this.saveSubmit == true) return this.plantCountry.length > 0;
            },

            validation_clientname() {
                  if (this.saveSubmitClient == true) return (this.clientName.length > 0 && /^((?![_./]).)*$/.test(this.clientName));
                  
                },
              validation_clientsurname() {
                  if (this.saveSubmitClient == true) return (this.clientSurname.length > 0 && /^((?![_./]).)*$/.test(this.clientSurname));
                  
                },
              validation_clientemail() {
                  if (this.saveClient == true) 
                  {
                    if(this.clientEmail.length>0 && this.reg.test(this.clientEmail))
                    return true
                    else
                    return false 
                  }  
                  
              },
              validation_clientbusinessName() {
                        if(this.saveSubmitClient==true) return (this.clientbusinessName.length > 0 && /^((?![_]).)*$/.test(this.clientbusinessName));
                    },
                validation_clientStreet() {
                        if(this.saveClient==true) return this.clientStreet.length > 0
                    },
                validation_clientPiva() {
                        if(this.saveSubmitClient==true) return this.clientPiva.length > 7 && this.clientPiva.length < 13
                    },
                validation_clientPhone() {
                        if(this.saveClient==true) return this.clientPhone.length > 0
                    },
                validation_clientNumber() {
                        if(this.saveClient==true) return this.clientNumber.length > 0
                    },
                validation_clientCity() {
                        if(this.saveClient==true) return this.clientCity.length > 0
                    },  
                validation_clientCap() {
                        if(this.saveClient==true) return this.clientCap.length > 0
                    },   
                validation_clientProv() {
                        if(this.saveClient==true) return this.clientProv.length > 0
                    },    
                validation_clientCountry() {
                        if(this.saveClient==true) return this.clientCountry.length > 0
                    }
    },
    mounted() {
        console.log("homeImpianto mounted, idImpianto=" + this.plantId,this.pid, this.$route)
        //if (this.plantId == null)
         this.plantId = this.$route.params.pid
        if (this.$store.state.user != null) {
            this.$store.dispatch('loadPlantDetails', this.plantId);
            if (!this.checkedInvitoPendente) {
                this.checkedInvitoPendente = true;
                console.log("verifico se ha invito pendente");
                this.$store.dispatch('getInvitoPendente');
            }
        }
        console.log("Logbook page mounted, idImpianto=" + this.plantId + ", logbookDetails:" + this.logbookDetails)
        if (this.$store.state.user != null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadLogbookDetails', this.plantId)
        }

    },
    updated() {
          console.log("UPDATED GENERAL IMPIANTO");

        },
    watch: {
        loading(val,oldval) {
            console.log("loading changed:" + val+", error=" + this.error+", loop=" + this.loop);
            if(this.plantDetails==null)
            {
             this.$store.dispatch('loadPlantDetails', this.$route.params.plantId);
            } 
            this.saveSubmit = false;
            this.chargeCurrentSettings();
        },    
        commandResponse(val,oldval) {
                console.log("updated commandResponse generaliimpianto: ", val, oldval,this.$store.state.currentPlant);
                
                if (val.pending == false && val.command == 'upgradePlant' ) {
                    this.updatingPro = false;
                    let self = this;
                    setTimeout(function() {
                    console.log("currentplant:",self.$store.state.currentPlant);

                    if (val.response.error != null) {
                        self.updatingPro = false;
                        self.$bvModal.msgBoxOk('Error:\n' + self.$t("errors." + val.response.error) , {
                        title: 'Errore',
                        okVariant: 'danger',
                        centered: true})
                    } 
                    else {
                        console.log("Upgraded to PRO!");
                        Vue.set(self.$store.state.currentPlant,"plant_type",val.response.data.plant_type);
                        Vue.set(self.$store.state.currentPlant,"pro_code",val.response.data.tokens);
                        Vue.set(self.$store.state.currentPlant,"pro_expiry",val.response.data.newExpiry);

                        //this.$store.state.currentPlant.plant_type = val.response.data.plant_type;
                        //this.$store.state.currentPlant.pro_code = val.response.data.tokens;
                        //this.$store.state.currentPlant.pro_expiry = val.response.data.newExpiry;
                        self.renewCode = '';
                        self.$forceUpdate();


                        if (val.response.data.tokens.length > 1) {
                            self.$bvModal.msgBoxOk(self.$t("settings.pro_code_renew"), {
                            title: self.$t("settings.pro_code_renew_title"),
                            okVariant: 'success',
                            centered: true
                            })
                        } else {
                          self.$bvModal.msgBoxOk(self.$t("settings.pro_code_upgrade"), {
                            title: self.$store$t("settings.pro_code_upgrade_title"),
                            okVariant: 'success',
                            centered: true
                            })
                        }
                        
                    }

                    },100);
                }
        }    
    },
    methods: {
    
    showInformativa() {
      console.log("State nomina user: " , this.$store.state.user);
      var acceptedDate= new Date(this.$store.state.user.nominaAccepted);
      if (acceptedDate.getFullYear()>2019 && acceptedDate.getFullYear()<2200)
      {
          console.log("Nomina già accettata in data",acceptedDate);
          return false
      }
      else
      {
          console.log("Nomina non accettata in data",acceptedDate);
          return true
      }    
    },
    logoUrl() {
      //return process.env.VUE_APP_ROOT_URL + "/img/loghi/Logo_" + this.plantDetails.id + '.jpg?rnd=' + Math.random();

      return process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id="+this.plantDetails.id+"&rnd=" + Math.random();
            

    },
    formatFileSize(size) {
      if (size >= 1000000) return (size / 1000000.0).toFixed(1) + " MB";
      if (size >= 1000) return (size / 1000.0).toFixed(1) + " KB";
      return size + " B";
    },
    sendingLogo(file,xhr,formData) {
        console.log("sendingImage",file,xhr,formData);
        console.log(file.type, file.dataURL);
        const buf = Buffer.from(file);
        console.log(buf.toString('base64'));
        //xhr.setRequestHeader("Content-Type","application/json")
    },
    logoAdded(file,dataUrl) {
        
        const self = this;
        const reader = new FileReader();
        const logoId = new Date().getTime();
        console.log("logo added",file, dataUrl, logoId);

        reader.onloadend = function(result) {
            console.log("result:",result);
            self.axios.post('', {
                action: 'uploadLogoNew',
                plantId: self.plantDetails.id,
                logoId: logoId,
                data: result.target.result
            })
                .then(function (response) {
                    console.log("post eseguita",response);
                    self.plantDetails["logoId"] = logoId;
                    self.$nextTick(() => {
                        self.$refs.myLogoDropzone.removeAllFiles();
                        self.$forceUpdate();
                    });
                })
                .catch(function (error) {
                    console.log("errore post",error);
                });
        }
        reader.readAsDataURL(file);
    },

    b64toBlob(b64Data, contentType='', sliceSize=512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },

    async downloadFile(docFile) {
      //let url = process.env.VUE_APP_ROOT_URL + "/plants_documents/" + docFile.id;
      console.log("download file:",docFile);
      let url = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=S3file&id="+ docFile.id;
      var downloadUrlResp = await this.axios.get(url);
      //console.log("downloadUrlResp:",downloadUrlResp);

      
      this.axios.get(downloadUrlResp.data.content_url, { responseType: 'blob', headers: {'Accept':'application/octet-stream'}})
        .then(async response  =>  {
          //console.log("response:",response);
          const blob = response.data
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = docFile.title
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error);
        
    },

    sendingFile(file,xhr,formData) {
        console.log("sendingFile",file,xhr,formData);
        //console.log(file.type, file.dataURL);
        //const buf = Buffer.from(file);
        //console.log(buf.toString('base64'));
        //xhr.setRequestHeader("Content-Type","application/json")
    },
    eliminaFile(docFile, index) {
      let self = this;
      console.log("chiamo deleteFile su plant " +  self.plantDetails.id+", fileId =" + docFile.id );
      this.$bvModal.msgBoxConfirm("Eliminare il file " + docFile.title+"?", {
        title: 'Conferma eliminazione file',
        okVariant: 'danger',
        okTitle: 'ELIMINA',
        cancelTitle: 'ANNULLA',
        centered: true
      }).then(async (value) => {
        var error = "";
        if (value == true) {
          try {
            var resp = await self.$store.dispatch("deleteFileNew", {plantId: self.plantDetails.id, fileId: docFile.id});
            console.log("resp eliminazione:",resp);
            if (resp.response.success == true) {
              self.plantDetails.documents.splice(index,1);
              return;
            }
            error = resp.response.error;
          } catch (err) {
            console.log("errore in eliminazione:",err);
            error = err;
          }

          this.$bvModal.msgBoxOk("Si è verificato un errore durante l'eliminazione del file\n " + error, {
            title: 'Errore eliminazione file',
            okVariant: 'danger',
            okTitle: 'OK',
            centered: true
          })
          
        }
      });

    },
    fileAdded(file,dataUrl) {
        
        const self = this;
        const reader = new FileReader();
        const logoId = new Date().getTime();
        console.log("file added",file, dataUrl, logoId);

        //let fileId = new Date().getTime();
        console.log("file uuid=" + file.upload.uuid);
        
        reader.onloadend = async function(result) {
            console.log("result:",result);
            
            const data = result.target.result;

            //let dataInfo = data.substring(5, data.indexOf(";base64,")+7).split(";");
            //console.log("dataInfo:",dataInfo);

            let mimeType = data.substring(5, data.indexOf(";base64"));
            console.log("mimeType:"+mimeType);

            
            //if (1>0) return;

            //data: result.target.result,
            // maxContentLength: 100000000,
            // maxBodyLength: 1000000000

            var resp = await self.axios.post('',{
                action: 'uploadFileS3',
                plantId: self.plantDetails.id,
                fileId: file.upload.uuid,
                fileName: file.name,
                contentType: mimeType,
                size: file.size
                
            } );
            console.log("esito uploadFileS3:",resp);

            /*
            {
                data: result.target.result,
                maxContentLength: 100000000,
                maxBodyLength: 1000000000
                
            }
            */

            self.axios.put(resp.data.upload_url, file, {
              headers: {
                'Content-Type': mimeType
              }
            })
                .then(function (response) {
                    console.log("post eseguita",response);




                    self.plantDetails["logoId"] = logoId;
                    if (self.plantDetails["documents"] == null) {
                        self.plantDetails["documents"] = [
                          {
                            id: self.plantDetails.id+"-"+file.upload.uuid,
                            title: file.name,
                            size: file.size
                          }
                        ];
                    } else {
                        self.plantDetails["documents"].push(
                          {
                            id: self.plantDetails.id+"-"+file.upload.uuid,
                            title: file.name,
                            size: file.size
                          }
                        );
                    } 
                    self.$nextTick(() => {
                        self.$refs.myFileDropzone.removeAllFiles();
                        self.$forceUpdate();
                    });
                })
                .catch(function (error) {
                    console.log("errore post",error);
                    self.$nextTick(() => {
                        self.$refs.myFileDropzone.removeAllFiles();
                        self.$forceUpdate();
                    });
                });
        }
        reader.readAsDataURL(file);
    },

    hasClient(){
            console.log("I dati del cliente sono: ", this.plantDetails.clientData);
            return this.plantDetails != null && this.plantDetails.clientData != null;
    },  
    ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) return user[0].role;
            return "admin";
    },
    modificaStatoNotifiche(checked) {
      console.log("modificato stato notifiche:" + checked);
      this.$store.dispatch("abilitaNotificheErrori",{enabled: checked, plantId: this.plantDetails.id});
      this.plantDetails["send_notifications"] = checked;
    },
    abilitaPro() {
      console.log("abilito pro..." + this.codicePro);
      if (this.codicePro.length != 16) {
        return;
      }
      this.updatingPro = true;
      this.$store.dispatch("abilitaPro",{code: this.codicePro, plantId: this.plantDetails.id});
    },   
    rinnovaPro() {
      console.log("rinnovo pro..." + this.renewCode);
      if (this.renewCode.length != 16) {
        return;
      }
      this.updatingPro = true;
      
      this.$store.dispatch("abilitaPro",{code: this.renewCode, plantId: this.plantDetails.id});
    },   
     chargeCurrentSettings() {
        this.plantId=this.$store.state.userLastPlants[0].id;
        this.plantName = this.$store.state.userLastPlants[0].plantname;
        this.plantStreet = this.$store.state.userLastPlants[0].address.street;
        this.plantNumber = this.$store.state.userLastPlants[0].address.housenumber;
        this.plantCity = this.$store.state.userLastPlants[0].address.city;
        this.plantCap = this.$store.state.userLastPlants[0].address.cap;
        this.plantProv = this.$store.state.userLastPlants[0].address.prov;
        this.plantCountry = this.$store.state.userLastPlants[0].address.country;

        this.fillClientData();

        this.errorNotifications = this.enableNotifications;

        console.log("CARICATI",this.$store.state.userLastPlants[0]);
        },
    fillClientData() {
      var p = this.$store.state.currentPlant;
      if (p != null && p.clientData != null) {
        var cl = p.clientData;
        this.clientPicked = cl.type;
        this.clientEmail = cl.email;
        this.clientPiva = cl.piva;
        this.clientPhone = cl.phone;
        this.clientStreet = cl.address.street;
        this.clientNumber = cl.address.housenumber;
        this.clientCity = cl.address.city;
        this.clientCap = cl.address.cap;
        this.clientProv = cl.address.prov;
        this.clientbusinessName = cl.businessname;
        this.clientName = cl.name;
        this.clientSurname = cl.surname;
        this.clientCountry = cl.address.country;
      } 

    },
    async saveClient() {

        this.saveSubmitClient = true;
        var tipo = this.clientPicked;

          if (tipo == 'company') {
            if (!this.validation_clientbusinessName || !this.validation_clientPiva) {
              //this.saveSubmit=false;
              return;
            }
          } else {
            if (!this.validation_clientname || !this.validation_clientsurname) {
              //this.saveSubmit=false;
              return;
            }
          }

          //if (!this.validation_name || !this.validation_surname || !this.validation_email) return; 
          console.log("Formattazione ok");
          var cliente = {
            type: this.clientPicked,
            businessname: (tipo == 'company') ? this.clientbusinessName : "",
            name: (tipo == 'company') ? "" : this.clientName,
            surname: (tipo == 'company') ? "" : this.clientSurname,
            piva: (tipo == 'company') ? this.clientPiva : "",
            phone:  this.clientPhone || "",
            email: this.clientEmail || "",
            address: {
              "country": this.clientCountry,
              "cap": this.clientCap,
              "prov": this.clientProv,
              "housenumber": this.clientNumber,
              "city": this.clientCity,
              "street": this.clientStreet
            }
          }
          console.log("cliente:",cliente);

          try {
            this.saveClientEnabled = false;
            var risposta = await this.$store.dispatch('aggiornaClienteImpianto', {mode:'form',plantId: this.$store.state.currentPlant.id, datiCliente: cliente});
            console.log("risposta:",risposta);
            this.saveClientEnabled = true;
            if (risposta.error) {
                this.savedMessage=this.$t("manage_client_modal.saved_error");
                this.$refs['modal-saved'].show();
            } else {
              this.saveSubmitClient = false;
              this.$store.state.currentPlant.clientData = risposta.response.datiCliente;
              this.fillClientData();
              this.savedMessage=this.$t("manage_client_modal.saved_data");
              this.$refs['modal-saved'].show();
            }

          } catch (err) {
            this.saveClientEnabled = true;
            this.saveSubmitClient = false;
            this.savedMessage=this.$t("manage_client_modal.saved_error");
            this.$refs['modal-saved'].show();
          }
    },

     handleOk() {
        if (this.showInformativa() == true) {

          if (this.nomina_checked != "accepted") {

            this.$bvModal.msgBoxOk("E' necessario prendere visione della nomina ed accettarla prima di procedere", {
            title: 'Dati errati',
            okTitle: 'OK',
            centered: true
          })

            return false;
          } else {
            var actualDate=new Date();
            console.log("Dispatch accettazione nomina",actualDate);
            this.$store.dispatch('dbSaveNomina',{acceptedDate: actualDate});
          }

        }

        this.saveSubmit = true;
        this.updatePlant();
        },
     updatePlant() {
        if (!this.validation_plantName || !this.validation_plantStreet || !this.validation_plantNumber || !this.validation_plantCity || !this.validation_plantCap) return; 
 
         var searchPlace = "";
    
            //Define var place
            var place =
            this.plantStreet +
            " " +
            this.plantNumber +
            " " +
            this.plantCity +
            " " +
            this.plantProv +
            " " +
            this.plantCountry;

            searchPlace =
            this.apiUrl + place + ".json?access_token=" + this.accessToken;

            console.log("SEARCH",searchPlace);
            //Get coordinates lat and long
            axios.get(searchPlace).then(response => {
            var longitude = response.data.features[0].center[0];
            var latitude = response.data.features[0].center[1];
            console.log("Coordinate-lat,long", latitude, longitude);
            this.$store.dispatch("dbUpdatePlant", {
                id: this.plantId,
                name: this.plantName,
                street: this.plantStreet,
                number: this.plantNumber,
                city: this.plantCity,
                cap: this.plantCap,
                prov: this.plantProv,
                country: this.plantCountry,
                lat: latitude,
                long: longitude
            });
            });
            
        },
        SavedData()
        {
          if(this.savedMessage!=this.$t('manage_client_modal.select_option'))
             this.$store.dispatch('loadPlantDetails',this.$store.state.currentPlant.id);
        }
    }
}

</script>

<style lang="scss">

#dropFilesContainer div.dz-message {
  margin-top: 0px;
  margin-bottom: 0px;
}


@media screen and (max-width: 767px) {
    #title-first, #title-pro, #title-edit, #title-map{
        margin-left: 1rem !important;
    }
    #sezione-general{
        margin-bottom: 4rem !important;
    }
    #card-pro, #card-edit, #card-map{
        margin-left: 0rem !important;
        margin-right: 0rem !important;
    }
}

</style>